import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, normalizeClass as _normalizeClass, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ce73f7b2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "homebox clearfix"
};
const _hoisted_2 = {
  class: "owin-height"
};
const _hoisted_3 = {
  class: "material-top"
};
const _hoisted_4 = {
  class: "material-main-title"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-icon"
}, null, -1));

const _hoisted_6 = {
  class: "text"
};
const _hoisted_7 = {
  class: "material-wrapper"
};
const _hoisted_8 = {
  class: "category-list"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode("归属学院");

const _hoisted_10 = {
  class: "category-title"
};
const _hoisted_11 = {
  class: "count"
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode("归属专业");

const _hoisted_13 = {
  class: "category-title"
};
const _hoisted_14 = {
  class: "count"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode("所获奖项");

const _hoisted_16 = {
  class: "category-title"
};
const _hoisted_17 = {
  class: "count"
};
const _hoisted_18 = {
  class: "material-box"
};
const _hoisted_19 = {
  key: 0,
  class: "material-list"
};
const _hoisted_20 = {
  key: 1,
  class: "empty-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_menu_item = _resolveComponent("el-menu-item");

  const _component_el_sub_menu = _resolveComponent("el-sub-menu");

  const _component_el_menu = _resolveComponent("el-menu");

  const _component_el_affix = _resolveComponent("el-affix");

  const _component_MaterialCard = _resolveComponent("MaterialCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event),
    menuCode: "11900"
  }, null, 8, ["menuInfo"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString($data.menuInfo.nav_name) + " ", 1)]), _createVNode(_component_el_input, {
    modelValue: $data.materialName,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.materialName = $event),
    size: "default",
    class: "search-input",
    onKeyup: _withKeys($options.handleSearch, ["enter"]),
    placeholder: "搜索教材名称"
  }, {
    suffix: _withCtx(() => [_createElementVNode("i", {
      class: "iconfont icon-sousuo search-icon",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.handleSearch && $options.handleSearch(...args))
    })]),
    _: 1
  }, 8, ["modelValue", "onKeyup"])]), _createElementVNode("div", _hoisted_7, [$data.filterFlag ? (_openBlock(), _createBlock(_component_el_affix, {
    key: 0,
    offset: 0
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [$data.filterFlag.indexOf('1') > -1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 0,
      "default-active": $data.searchInfo.collegeId,
      "default-openeds": ['1']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "1"
      }, {
        title: _withCtx(() => [_hoisted_9]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.collegeList, ({
          organName,
          id,
          courseNum = 0
        }, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            key: index,
            class: _normalizeClass(["category-item", $data.searchInfo.collegeId == id ? 'active-tag' : '']),
            index: id + '',
            onClick: $event => $options.collegeChange(id, organName)
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_10, _toDisplayString(organName), 1), _createElementVNode("span", _hoisted_11, "(" + _toDisplayString(courseNum) + ")", 1)]),
            _: 2
          }, 1032, ["class", "index", "onClick"])), [[_vShow, $data.showMoreCollege || index < 6]]);
        }), 128)), $data.collegeList.length > 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category-btn",
          onClick: _cache[3] || (_cache[3] = (...args) => $options.toggleShowCollege && $options.toggleShowCollege(...args))
        }, _toDisplayString($data.showMoreCollege ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true), $data.filterFlag.indexOf('2') > -1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 1,
      "default-active": $data.searchInfo.majorId,
      "default-openeds": ['2']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "2"
      }, {
        title: _withCtx(() => [_hoisted_12]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.majorList, ({
          major_name,
          id,
          count = 0
        }, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            key: index,
            class: _normalizeClass(["category-item", $data.searchInfo.majorId == id ? 'active-tag' : '']),
            index: id + '',
            onClick: $event => $options.majorChange(id, major_name)
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_13, _toDisplayString(major_name), 1), _createElementVNode("span", _hoisted_14, "(" + _toDisplayString(count) + ")", 1)]),
            _: 2
          }, 1032, ["class", "index", "onClick"])), [[_vShow, $data.showMoreMajor || index < 6]]);
        }), 128)), $data.majorList.length > 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category-btn",
          onClick: _cache[4] || (_cache[4] = (...args) => $options.toggleShowMajor && $options.toggleShowMajor(...args))
        }, _toDisplayString($data.showMoreMajor ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true), $data.filterFlag.indexOf('3') > -1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 2,
      "default-active": $data.searchInfo.awardId,
      "default-openeds": ['3']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "3"
      }, {
        title: _withCtx(() => [_hoisted_15]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.awardList, ({
          name,
          id,
          count = 0
        }, index) => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            key: index,
            class: _normalizeClass(["category-item", $data.searchInfo.awardId == id ? 'active-tag' : '']),
            index: id + '',
            onClick: $event => $options.awardChange(id, name)
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_16, _toDisplayString(name), 1), _createElementVNode("span", _hoisted_17, "(" + _toDisplayString(count) + ")", 1)]),
            _: 2
          }, 1032, ["class", "index", "onClick"]);
        }), 128))]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true)])]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [$data.materialList && $data.materialList.length ? (_openBlock(), _createElementBlock("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.materialList, item => {
    return _openBlock(), _createBlock(_component_MaterialCard, {
      itemData: item,
      key: item.id,
      onClick: $event => $options.toDetail(item.id)
    }, null, 8, ["itemData", "onClick"]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])), $data.pageInfo.rows && $data.pageInfo.rows > $data.pageInfo.pageLimit ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 2,
    class: "material-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    onCurrentChange: $options.handleChangePage,
    "current-page": $data.pageInfo.pageIndex,
    total: $data.pageInfo.rows,
    "page-size": $data.pageInfo.pageLimit
  }, null, 8, ["onCurrentChange", "current-page", "total", "page-size"])) : _createCommentVNode("", true)])])]), _createVNode(_component_Footer)]);
}